import { UpdateWorkflowRequest } from 'services/workflowService/workflowService';
import { Workflow } from '../../types/workflow/workflow.types';

export interface WorkflowsState {
  workflows: Workflow[];
  selectedWorkflow: Workflow | null;
  loading: boolean;
  error: string | null;
  updateLoading: boolean;
  publishLoading: boolean;
}

export const WORKFLOWS_ACTION_TYPES = {
  // Fetch workflows
  FETCH_WORKFLOWS_REQUEST: 'workflows/FETCH_WORKFLOWS_REQUEST',
  FETCH_WORKFLOWS_SUCCESS: 'workflows/FETCH_WORKFLOWS_SUCCESS',
  FETCH_WORKFLOWS_FAILURE: 'workflows/FETCH_WORKFLOWS_FAILURE',

  // Get workflow by campaign ID
  GET_WORKFLOW_BY_CAMPAIGN_REQUEST:
    'workflows/GET_WORKFLOW_BY_CAMPAIGN_REQUEST',
  GET_WORKFLOW_BY_CAMPAIGN_SUCCESS:
    'workflows/GET_WORKFLOW_BY_CAMPAIGN_SUCCESS',
  GET_WORKFLOW_BY_CAMPAIGN_FAILURE:
    'workflows/GET_WORKFLOW_BY_CAMPAIGN_FAILURE',

  // Update workflow
  UPDATE_WORKFLOW_REQUEST: 'workflows/UPDATE_WORKFLOW_REQUEST',
  UPDATE_WORKFLOW_SUCCESS: 'workflows/UPDATE_WORKFLOW_SUCCESS',
  UPDATE_WORKFLOW_FAILURE: 'workflows/UPDATE_WORKFLOW_FAILURE',

  // Publish workflow
  PUBLISH_WORKFLOW_REQUEST: 'workflows/PUBLISH_WORKFLOW_REQUEST',
  PUBLISH_WORKFLOW_SUCCESS: 'workflows/PUBLISH_WORKFLOW_SUCCESS',
  PUBLISH_WORKFLOW_FAILURE: 'workflows/PUBLISH_WORKFLOW_FAILURE',

  // Clear state
  CLEAR_WORKFLOW_STATE: 'workflows/CLEAR_WORKFLOW_STATE',
} as const;

export interface FetchWorkflowsRequestAction {
  type: typeof WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_REQUEST;
}

export interface FetchWorkflowsSuccessAction {
  type: typeof WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_SUCCESS;
  payload: Workflow[];
}

export interface FetchWorkflowsFailureAction {
  type: typeof WORKFLOWS_ACTION_TYPES.FETCH_WORKFLOWS_FAILURE;
  payload: string;
}

export interface GetWorkflowByCampaignRequestAction {
  type: typeof WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_REQUEST;
  payload: string; // campaignId
  [key: string]: any;
}

export interface GetWorkflowByCampaignSuccessAction {
  type: typeof WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_SUCCESS;
  payload: Workflow;
}

export interface GetWorkflowByCampaignFailureAction {
  type: typeof WORKFLOWS_ACTION_TYPES.GET_WORKFLOW_BY_CAMPAIGN_FAILURE;
  payload: string;
}

export interface UpdateWorkflowRequestAction {
  type: typeof WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_REQUEST;
  payload: UpdateWorkflowRequest;
  [key: string]: any;
}

export interface UpdateWorkflowSuccessAction {
  type: typeof WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_SUCCESS;
  payload: Workflow;
}

export interface UpdateWorkflowFailureAction {
  type: typeof WORKFLOWS_ACTION_TYPES.UPDATE_WORKFLOW_FAILURE;
  payload: string;
}

export interface PublishWorkflowRequestAction {
  type: typeof WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_REQUEST;
  payload: {
    campaignId: string;
    flow: {
      nodes: any[];
      edges: any[];
    };
  };
}

export interface PublishWorkflowSuccessAction {
  type: typeof WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_SUCCESS;
  payload: Workflow;
}

export interface PublishWorkflowFailureAction {
  type: typeof WORKFLOWS_ACTION_TYPES.PUBLISH_WORKFLOW_FAILURE;
  payload: string;
}

export interface ClearWorkflowStateAction {
  type: typeof WORKFLOWS_ACTION_TYPES.CLEAR_WORKFLOW_STATE;
}

export type WorkflowsActionTypes =
  | FetchWorkflowsRequestAction
  | FetchWorkflowsSuccessAction
  | FetchWorkflowsFailureAction
  | GetWorkflowByCampaignRequestAction
  | GetWorkflowByCampaignSuccessAction
  | GetWorkflowByCampaignFailureAction
  | UpdateWorkflowRequestAction
  | UpdateWorkflowSuccessAction
  | UpdateWorkflowFailureAction
  | PublishWorkflowRequestAction
  | PublishWorkflowSuccessAction
  | PublishWorkflowFailureAction
  | ClearWorkflowStateAction;
